export default __webpack_public_path__ + "static/media/ic_azerbaijan.c6029dfc.svg";